<div class="manage-queries-dialog">
  <!-- Header with total count and rows per page -->
   <!-- <div>
    Search
   </div> -->
    <div class="row-page w100">
        <form class="w100" nz-form [formGroup]="savedQueryForm" [nzLayout]="'vertical'" (ngSubmit)="searchSubmit()">
         <!-- <div nz-row> -->
        <div class="row-page w100">
        <!-- <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24" nzXs="24"> -->
        <nz-form-item class="w-50p">
          <nz-form-label nzFor="infoReqNum">Query Name
            <span nz-tooltip nzTooltipTitle="Query Name">
              <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
            </span>
          </nz-form-label>
          <nz-form-control>
            <input nz-input placeholder="Query Name" id="queryName" formControlName="queryName" />
          </nz-form-control>
        </nz-form-item>
      <!-- </div> -->
      <div class="w-50p-flex-end">
         <button type="button" nz-button id="resetForm" (click)="resetForm()" class="mr-sm"><i nz-icon
              nzType="close-circle" nzTheme="outline"></i>
            Reset</button> 
          <button nz-button type="submit" id="submit" [nzType]="'primary'" [nzLoading]="loading"><i nz-icon
              nzType="search" nzTheme="outline"></i>
           Search</button>
      </div>   
        </div>
           
      <!-- </div> -->
    </form>
    </div>
  <div class="mb-md flex-between">
    
   
    <div class="fw-600">
      Saved Queries ({{ totalElements }})
    </div>
    <div>
      <span class="mr-sm">Rows per page:</span>
      <nz-select [(ngModel)]="size" (ngModelChange)="onPageSizeChange($event)" class="w80">
        <nz-option [nzValue]="5" nzLabel="5"></nz-option>
        <nz-option [nzValue]="10" nzLabel="10"></nz-option>
        <nz-option [nzValue]="20" nzLabel="20"></nz-option>
        <nz-option [nzValue]="50" nzLabel="50"></nz-option>
      </nz-select>
    </div>
  </div>

  <nz-spin [nzSpinning]="loading">
    <nz-table
      class="declaration-table"
      #savedQueriesTable
      [nzData]="savedQueries"
      [nzFrontPagination]="false"
      [nzTotal]="totalElements"
      [nzPageSize]="size"
      [nzPageIndex]="pageIndex"
      [nzShowPagination]="false"
      nzSize="small"
      [nzScroll]="{ y: '300px' }"
    >
      <thead (nzSortOrderChange)="sort($event)" nzSingleSort>
        <tr>
          <th nzShowSort nzColumnKey="queryName" [nzSortFn]="true">Query Name</th>
          <th nzWidth="140px" nzShowSort nzColumnKey="createdDate" [nzSortFn]="true">Creation Date</th>
          <th nzWidth="100px" nzAlign="center">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let query of savedQueriesTable.data" class="query-row">
          <td>
            <a href="javascript:;" (click)="onApplyQuery(query)" class="query-name-link">{{ query.queryName }}</a>
            <nz-tag *ngIf="query.isDefault" nzColor="blue" class="default-tag">Default</nz-tag>
          </td>
          <td>{{ formatDate(query.createdDate || query.modifiedDate) }}</td>
          <td class="text-center">
             <a nz-button nz-dropdown [nzDropdownMenu]="menu">
          <i nz-icon nzType="more" nzTheme="outline"></i>
        </a>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item *ngIf="!query.isDefault" (click)="onSetDefault(query)">
                  <i nz-icon nzType="star" nzTheme="outline"></i>
                  Make as Default
                </li>
                <li nz-menu-item (click)="onRename(query)">
                  <i nz-icon nzType="edit" nzTheme="outline"></i>
                  Rename
                </li>
                <li nz-menu-item nzDanger (click)="onDelete(query)">
                  <i nz-icon nzType="delete" nzTheme="outline"></i>
                  Delete
                </li>
              </ul>
            </nz-dropdown-menu>
          </td>
        </tr>
      </tbody>
    </nz-table>

    <!-- Custom pagination -->
    <div class="mt-md pagination-container" *ngIf="totalElements > 0">
      <div>
        <nz-pagination [nzPageIndex]="pageIndex" [nzTotal]="totalElements" [nzPageSize]="size" (nzPageIndexChange)="onPageChange($event)"></nz-pagination>
      </div>
      <div>
        <span class="mr-sm">Go to:</span>
        <input nz-input [(ngModel)]="gotoPageNumber"
               placeholder="Page"
               type="number"
               [min]="1"
               [max]="maxPages"
               class="w80 inline-block mr-sm"
               (keyup.enter)="goToPage()" />
        <button nz-button nzType="primary" (click)="goToPage()" [disabled]="!gotoPageNumber">Go</button>
      </div>
    </div>

    <!-- <div *ngIf="savedQueries.length === 0 && !loading" class="empty-state">
      <nz-empty nzNotFoundContent="No saved queries found"></nz-empty>
    </div> -->
  </nz-spin>

  <!-- <div class="dialog-footer">
    <button nz-button nzType="default" (click)="onClose()">
      Close
    </button>
  </div> -->
</div>
